import { Grid } from "@mui/material";
import { useAuthorize } from "../../../../hooks/use-authorize";
import { UserPermissionName } from "../../../../models/user-permission-name";
import { DetailsTabComponent } from "./details-tab.component";
import { useNavigate, useParams } from "react-router-dom";
import { SiTrackPage } from "../../../../components/si-track-page";
import { municipalityApiKeyStore } from "../../../../api/masters/municipality-api-key-store";
import { useLoadData } from "../../../../hooks/useLoadData";
import { ApiResponse } from "../../../../models/api-response";
import { MunicipalityInfo } from "./municipality-info.component";
import { TemplateInfo } from "./template-info.component";
import { PageAddressInfo } from "./page-address-info.component";

export const MunicipalityDetailsPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { data, isLoading } = useLoadData<ApiResponse<any>>(municipalityApiKeyStore.getMunicipality(id));

    const handleEditOffice = (value: any) => {
        navigate(`/masters/municipality/edit/${id}`);
    };

    const permissionForTab = {
        contactTab: useAuthorize([UserPermissionName.VIEW_CONTACT]),
        noteTab: useAuthorize([UserPermissionName.VIEW_NOTE]),
    };
    
    return (
        <SiTrackPage
            title={data?.data?.muncipalityName ?? ''}
            onEdit={handleEditOffice}
            isLoading={isLoading}
            actionPermissions={{ edit: UserPermissionName.EDIT_MUNICIPALITY }}
        >
            <Grid container spacing={2}>
                <Grid item lg={6} sm={6} xl={6} xs={6}>
                    <MunicipalityInfo municipality={data?.data} isLoading={isLoading} />
                </Grid>
                
                <Grid item lg={6} sm={6} xl={6} xs={6}>
                    <Grid container spacing={1}>
                        <Grid item lg={12} sm={12} xl={12} xs={12}>
                            <TemplateInfo municipality={data?.data} isLoading={isLoading} />
                        </Grid>
                        <Grid item lg={12} sm={12} xl={12} xs={12}>
                            <PageAddressInfo municipality={data?.data} isLoading={isLoading} />
                        </Grid>
                    </Grid>
                </Grid>
                
                {!permissionForTab?.contactTab && !permissionForTab?.noteTab ? null : (
                    <Grid item lg={12} sm={12} xl={12} xs={12}>
                        <DetailsTabComponent municipalityID={Number(id)} permissionForTab={permissionForTab} />
                    </Grid>
                )}
            </Grid>
        </SiTrackPage>
    );
}